import { ModalForm } from '@/components/Modal/ModalForm'
import { ApiHookCallback, useApiRequest } from '@/endpoints/hooks'
import { useAppContext } from '@/hooks'
import { useDeleteTemplateMutation } from '@/rtkApi'

type RemoveModalProps = {
	callback?: (id: number, ...params: unknown[]) => ApiHookCallback<void>
	header: string
	isTemplate?: boolean
	onClose: () => void
	/** When set, used instead of `callback` for non-template deletes (e.g. RTK mutations). */
	onDelete?: (id: number) => Promise<void>
	onRemove?: () => void
	params?: unknown[]
	removeId: number | undefined
	styles?: React.CSSProperties
	textOnModal: string
}

export const RemoveModal = ({
	callback,
	header,
	isTemplate = false,
	onClose,
	onDelete,
	onRemove,
	params,
	removeId,
	styles = { width: '400px' },
	textOnModal,
}: RemoveModalProps) => {
	const { t } = useAppContext()
	const request = useApiRequest()
	const [deleteMutation] = useDeleteTemplateMutation()

	const handleSubmit = async () => {
		if (!removeId) return

		if (isTemplate) {
			await deleteMutation?.({ id: removeId })
			onClose()
			return
		}

		if (onDelete) {
			await onDelete(removeId)
		} else if (callback) {
			await request(callback(removeId, ...(params ?? [])))
		}

		onRemove?.()
		onClose()
	}

	return (
		<ModalForm<FormData>
			open={true}
			onClose={onClose}
			saveTitle={t('REMOVE')}
			saveSchema="danger"
			contentStyle={styles}
			header={header}
			onSubmit={handleSubmit}
			data-testid="remove-modal"
		>
			{textOnModal}
		</ModalForm>
	)
}
